import style from "../style/HMNICard.module.css";

export default function HMNICard() {
    return (
        <div className={style.card}>
            <div className={style.header}>
                <h2>HELLO</h2>
                <p>my name is</p>
            </div>

            <div className={style.field}>
                <h3>Emil Albrecht</h3>
            </div>
        </div>
    )
}